import api from "@/api/api-v2-config";

export async function getOpportunityListAxios() {
    return await api.get("opportunities?PageNumber=1&PageSize=1000000");
}

export async function deleteOpportunityAxios(id) {
    return await api.delete("opportunities/" + id);
}

export async function postOpportunityAxios(payload) {
    return await api.post("opportunities", payload);
}

export async function putOpportunityAxios(id, payload) {
    console.log("updated being called", payload)
    return await api.put("opportunities/" + id, payload);
}

export async function getOpportunityByIdAxios(id) {
    return await api.get("opportunities/" + id);
}

export async function updateOpportunityStatus(payload) {
    return await api.put("opportunities/updateopportunitystatus", payload);
}

export async function getOpportunityPipelines(payload) {
    return await api.get("opportunities/getopportunitypipelines?PageNumber=1&PageSize=1000000", payload);
}

export async function updateOpportunityPipelines(payload) {
    return await api.put("opportunities/updateopportunitypipeline", payload);
}